import { Box, Step, StepLabel, Stepper, Typography } from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import "react-circular-progressbar/dist/styles.css";
import { generateStatusHistorySteps } from "../../../../utils/statusHistoryUtils";
import { PieProgress } from "../PieProgess";
import { CustomConnector } from "./CustomConnecter";
import { CustomStepIcon } from "./CustomIcon";
import LineStatusPopover from "./LineStatusPopover";

export const Timeline = ({ order, line_id, mode = "order" }) => {
	const [statusHistories, setStatusHistories] = useState([]);
	const [currentStatus, setCurrentStatus] = useState(0);

	useEffect(() => {
		if (!order) {
			return;
		}

		const { histories, current_index } = generateStatusHistorySteps({
			order,
			lineId: line_id,
			mode: mode,
		});

		setCurrentStatus(current_index);

		setStatusHistories(histories);
		console.log("HISTORIES>>>>>>>>>>>>>>>>", histories)
	}, [line_id, mode, order]);

	

	return (
		<Box py={2}>
			<Stepper
				alternativeLabel
				activeStep={currentStatus + 1}
				connector={<CustomConnector mode={mode} />}
			>
				{statusHistories.map((step, i) => {
					const percentage =
						step?.order_lines?.length > 0
							? Math.round(
									(step.lines.length /
										step.order_lines.length) *
										100
							  )
							: 0;

					return (
						<Step
							key={`${mode}-${step.label}`}
							completed={step.completed}
						>
							<StepLabel
								StepIconComponent={(props) => (
									<CustomStepIcon
										{...props}
										statusHistories={statusHistories}
										currentStatus={currentStatus}
									/>
								)}
							>
								{step.label}
								{step.changed_at && (
									<Typography variant="subtitle1">
										{moment(step.changed_at).format(
											"DD/MM/YYYY hh:mm a"
										)}
									</Typography>
								)}
								{!step.completed && step.lines?.length > 0 && (
									<>
										<PieProgress
											percentage={percentage}
											size={20}
										/>

										<LineStatusPopover lines={step.lines} />
									</>
								)}
							</StepLabel>
						</Step>
					);
				})}
			</Stepper>
		</Box>
	);
};
